import React from 'react';
import ReactDOM from 'react-dom/client';
import { QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { RouterProvider } from '@tanstack/react-router';
import { MsalProvider } from '@azure/msal-react';
import { TooltipProvider } from '@/components/ui/tooltip';
import { AuthProvider } from '@/contexts/AuthContext';
import { msalInstance } from '@/config/msalConfig';
import { queryClient } from './services/queryClient';
import { router } from './routes';
import './globals.css';

const rootElement = document.getElementById('root');

if (!rootElement) {
  throw new Error('Failed to find the root element');
}

// handleRedirectPromise() must run before the router mounts so MSAL extracts
// the auth code from the URL hash before TanStack Router's auth guards execute.
msalInstance
  .initialize()
  .then(() => msalInstance.handleRedirectPromise())
  .catch((error) => {
    console.error('MSAL redirect handling failed:', error);
  })
  .finally(() => {
    ReactDOM.createRoot(rootElement).render(
      <React.StrictMode>
        <MsalProvider instance={msalInstance}>
          <AuthProvider>
            <QueryClientProvider client={queryClient}>
              <TooltipProvider>
                <RouterProvider router={router} />
              </TooltipProvider>

              {import.meta.env.DEV && (
                <ReactQueryDevtools
                  initialIsOpen={false}
                  position="bottom"
                  buttonPosition="bottom-right"
                />
              )}
            </QueryClientProvider>
          </AuthProvider>
        </MsalProvider>
      </React.StrictMode>,
    );
  });
